import React from 'react';
import { sellerConstants } from '../../_constants/seller.constants';
import swal from 'sweetalert2/dist/sweetalert2.min.js';
import SweetAlert from 'sweetalert2-react';



const initialState = { sellerImageLoading: true, data: '', error: false, errorText: '', showSwal: true };

export function sellerImage(state = initialState, action) {
  switch (action.type) {
    case sellerConstants.REQUEST_ADD_SELLER_IMAGE:
      return {
        sellerImageLoading: true,
        data: '',
        error: false,
        errorText: ''
      };
    case sellerConstants.ADD_SELLER_IMAGE_SUCCESS:

      return {
        sellerImageLoading: false,
        data: action.data,
        error: false,
        errorText: ''
      };
    case sellerConstants.ADD_SELLER_IMAGE_ERROR:

      swal({
        type: "error",
        text: "Image size should be 200px*200px.",
      });

      return {
        sellerImageLoading: false,
        data: '',
        error: true,
        errorText: action.error
      };
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/_reducers/sellers/sellerImage.reducer.js